import { HotelReservationWithRefundProcess } from "@/types/hotelReservation";
import { UserSubscriptionWithRefundProcess } from "@/types/userSubscription";
import { PurchasedProductWithRefundProcess } from "@/types/purchasedProduct";
import { FlightDelayWithRefundProcess } from "@/types/flightReservation";
import { BillWithRefundProcess } from "@/types/bill";

export type RefundProcessItem =
  | HotelReservationWithRefundProcess
  | UserSubscriptionWithRefundProcess
  | PurchasedProductWithRefundProcess
  | FlightDelayWithRefundProcess
  | BillWithRefundProcess;

// Type guards using pk prefix
export const isHotelReservation = (
  item: RefundProcessItem
): item is HotelReservationWithRefundProcess =>
  item.pk.startsWith("HOTELRES0#");

export const isUserSubscription = (
  item: RefundProcessItem
): item is UserSubscriptionWithRefundProcess => item.pk.startsWith("USERSUB0#");

export const isPurchasedProduct = (
  item: RefundProcessItem
): item is PurchasedProductWithRefundProcess =>
  item.pk.startsWith("PURCHASEDPROD0#");

export const isFlightDelay = (
  item: RefundProcessItem
): item is FlightDelayWithRefundProcess => item.pk.startsWith("FLIGHTRES0#");

export const isBill = (
  item: RefundProcessItem
): item is BillWithRefundProcess => item.pk.startsWith("USER_BILL#");

// Utility to get platform/service name
export const getPlatformName = (item: RefundProcessItem): string => {
  if (isHotelReservation(item)) {
    return item.hotelPlatform || "Unknown";
  }
  if (isUserSubscription(item)) {
    return item.serviceName;
  }
  if (isPurchasedProduct(item)) {
    return item.retailer;
  }
  if (isFlightDelay(item)) {
    return item.airline;
  }
  if (isBill(item)) {
    return item.provider;
  }
  throw new Error(
    `Unknown refund process item type with pk: ${(item as any).pk}`
  );
};

// Utility to get phone number (only available for hotel reservations)
export const getPhoneNumber = (item: RefundProcessItem): string => {
  if (isHotelReservation(item) && item.phoneNumber) {
    return item.phoneNumber;
  }
  return "Contact number";
};
